import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'workflowQtyDiscountOperators', pure: false })
export class WorkflowQtyDiscountOperatorsPipe implements PipeTransform {

    transform(qtyOperators: Array<any>, selectedOperator: any, otherSelectedOperators: Array<any>): any {
        if (qtyOperators && qtyOperators.length && otherSelectedOperators) {

            const otherOperators: string[] = otherSelectedOperators.filter(f=> f.operator && f.operator!=selectedOperator).map(f=> f.operator)

            return qtyOperators.filter(obj => !otherOperators.includes(obj.id));
        } else {
            return qtyOperators
        }
    }

}
